import axiosInstance from "./axiosInstance";

// ================= TYPES =================

export interface PaginationParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

// ================= AUTH =================

export const loginUser = (data: { email: string; password: string }) =>
  axiosInstance.post("/auth/login", data);

export const registerUser = (data: {
  name: string;
  email: string;
  password: string;
}) => axiosInstance.post("/auth/register", data);

export const sendOtp = (data: { email: string }) =>
  axiosInstance.post("/auth/send-otp", data);

export const resetPassword = (data: {
  email: string;
  otp: string;
  password: string;
}) => axiosInstance.post("/auth/reset-password", data);

export const resendOtp = (data: { email: string }) =>
  axiosInstance.post("/auth/resend-otp", data);

// ================= DASHBOARD =================

export const getDashboardStats = (params?: {
  from?: string;
  to?: string;
  product?: string;
}) => axiosInstance.get("/dashboard", { params });

// ================= LEADS =================

export const createLead = (data: FormData) =>
  axiosInstance.post("/leads", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const updateLeadStatus = (id: string, data: any) =>
  axiosInstance.put(`/leads/${id}/status`, data);

export const getLeads = (params?: PaginationParams) =>
  axiosInstance.get("/leads", { params });

export const getLeadById = (id: string) => axiosInstance.get(`/leads/${id}`);

export const updateLead = (id: string, data: FormData) =>
  axiosInstance.put(`/leads/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// ================= LOANS =================

export const saveLoanDetails = (leadId: string, data: FormData) =>
  axiosInstance.post(`/loans/save-or-update/${leadId}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getLoans = (params?: any) =>
  axiosInstance.get("/loans", { params });

export const getLoanById = (id: string) => axiosInstance.get(`/loans/${id}`);

// ================= 💰 DISBURSEMENT =================

// 🔥 UPDATED ROUTES
export const saveDisbursement = (loanId: string, data: any) =>
  axiosInstance.post(`/disbursement/save/${loanId}`, data);

export const getDisbursements = (params?: any) =>
  axiosInstance.get("/disbursement", { params });

export const getDisbursementByLoanId = (loanId: string) =>
  axiosInstance.get(`/disbursement/loan/${loanId}`);

// ================= 💸 COMMISSION =================

// 🔥 CREATE (FormData for file upload)
export const createCommission = (data: any) =>
  axiosInstance.post("/commission", data);

// 📋 Get all commissions
export const getCommissions = (params?: any) =>
  axiosInstance.get("/commission", { params });

// ✏️ Update commission
export const updateCommission = (id: string, data: any) =>
  axiosInstance.put(`/commission/${id}`, data);

// 💰 Mark as paid
export const payCommission = (id: string) =>
  axiosInstance.put(`/commission/${id}/pay`, {
    status: "paid",
  });

// ================= 🔔 NOTIFICATIONS =================

// 📥 Get all notifications
export const getNotifications = () => axiosInstance.get("/notifications");

// 🔢 Get unread count (badge)
export const getUnreadCount = () =>
  axiosInstance.get("/notifications/unread-count");

// 📩 Mark single notification as read
export const markNotificationRead = (id: string) =>
  axiosInstance.patch(`/notifications/read/${id}`);

// 🔥 OPTIONAL (recommended)
// 📩 Mark all as read
export const markAllNotificationsRead = () =>
  axiosInstance.patch("/notifications/read-all");

// ================= 📊 EXPORT =================

// 📥 Export ALL leads (multi-sheet excel ke liye data)
export const exportAllLeads = () => axiosInstance.get("/export/leads");

// 📄 Export SINGLE lead (full detail)
export const exportSingleLead = (id: string) =>
  axiosInstance.get(`/export/lead/${id}`);
